import React from 'react';
import {connect} from 'react-redux';
import Alert from 'antd/lib/alert';
import Form from 'antd/lib/form';
import Input from 'antd/es/input';
import Button from 'antd/es/button';
import {
  cancelReplyToComment,
  cancelUpdateComment,
  handleAddComment,
  handleCommentFieldChange,
  replyToComment,
  updateComment,
} from '../../redux/actions/Comments';

const {TextArea} = Input;

const CommentEditorFormPre = props => {
  const {
    util: {isUserLoggedIn},
    comments: {submitting, commentText, updatingCommentData, replyingCommentData},
    handleCommentFieldChange,
    handleAddComment,
    updateComment,
    cancelUpdateComment,
    replyToComment,
    cancelReplyToComment,
  } = props;

  const isDisabled = commentText === '' || commentText === ' ' || commentText === '  ';

  const buildCommentFormButton = () => {
    if (updatingCommentData.commentId !== '') {
      return <Button
          htmlType="submit"
          loading={submitting}
          onClick={updateComment}
          type="primary"
          disabled={isDisabled}
      >
        Post
      </Button>;
    } else if (replyingCommentData.commentId !== '') {
      return <Button
          htmlType="submit"
          loading={submitting}
          onClick={replyToComment}
          type="primary"
          disabled={isDisabled}
      >
        Post
      </Button>;
    } else return <Button
        htmlType="submit"
        loading={submitting}
        onClick={handleAddComment}
        type="primary"
        disabled={isDisabled}
    >
      Add Comment
    </Button>;
  };

  return (
      <div className="comment-editor-section">
        <Form>
          {
            updatingCommentData.commentId !== '' && <Alert
                className="comment-alert-box"
                message="Editing the comment" type="info"
                closable
                onClose={cancelUpdateComment}
            />
          }
          {
            replyingCommentData.commentId !== '' && <Alert
                className="comment-alert-box"
                message={'Replying to ' + replyingCommentData.commentAuthor}
                type="info"
                closable
                onClose={cancelReplyToComment}
            />
          }
          <Form.Item>
            <TextArea
                rows={4}
                onChange={e => handleCommentFieldChange(e.target.value)}
                value={commentText}
                className="comment-field mc-ml-5"
                disabled={!isUserLoggedIn}
            />
          </Form.Item>
          <Form.Item>
            {buildCommentFormButton()}
          </Form.Item>
        </Form>
      </div>
  );
};

const mapStateToProps = state => {
  return state;
};

const CommentEditorForm = connect(mapStateToProps, {
  handleCommentFieldChange,
  handleAddComment,
  cancelUpdateComment,
  updateComment,
  cancelReplyToComment,
  replyToComment,
})(CommentEditorFormPre);

export {CommentEditorForm};
